import {WidgetCard} from '../Marketplace';
import * as React from 'react';
import {CardGroup, Row} from 'react-bootstrap';
import {buildRoute} from '../../navigation/navigationUtils';
import {DASHBOARD_ROUTES} from '../../navigation/dashboard/DashboardRoutes';
import {usePulsoidClient} from '../../../PulsoidClient';
import {
  LivIntegrationCard,
  LumiaIntegrationsCard,
  VtsHeartRateIntegrationCard,
  StreamDeckIntegrationCard,
  AutomatedClipsIntegrationCard,
  ReportsIntegrationCard,
  AitumIntegrationCard,
  StreamerBot,
  MagicChatbox,
  OyasumiVR,
  AiLicia,
  Overwolf,
  Tits,
  VRCOSC,
  Racelab,
  SAMMI,
} from '../../integrations/Marketplace';

const RecommendedIntegrations = [
  <LumiaIntegrationsCard />,
  <LivIntegrationCard />,
  <VtsHeartRateIntegrationCard />,
  <StreamDeckIntegrationCard />,
  <AutomatedClipsIntegrationCard />,
  <ReportsIntegrationCard />,
  <AitumIntegrationCard />,
  <StreamerBot />,
  <MagicChatbox />,
  <OyasumiVR />,
  <AiLicia />,
  <Overwolf />,
  <Tits />,
  <VRCOSC />,
  <Racelab />,
  <SAMMI />,
];

export const Recommendations = ({predefinedWidgets, excludedMetaId}) => {
  let pulsoidClient = usePulsoidClient();

  let advancedWidgets = predefinedWidgets
    .filter(
      (widget) => widget.tags.filter((tag) => tag.key === 'advanced').length > 0
    )
    .filter((widget) => widget.metaId !== excludedMetaId);

  let [integration, setIntegration] = React.useState(undefined);

  // init recommendation with random recommendation
  React.useEffect(() => {
    setIntegration(
      RecommendedIntegrations[
        Math.floor(Math.random() * RecommendedIntegrations.length)
      ]
    );
  }, []);

  if (advancedWidgets.length > 0) {
    return (
      <>
        <br />
        <Row
          style={{
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '10px',
          }}
        >
          <h2>You may also like</h2>
        </Row>
        <h5 style={{fontSize: '14px'}}>
          Advanced widgets for your live stream
        </h5>
        <hr />
        <Row
          style={{
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '10px',
          }}
        >
          <CardGroup>
            {advancedWidgets.slice(0, 2).map((widget) => (
              <WidgetCard
                key={widget?.id}
                predefinedWidget={widget}
                heartRate={80}
                addNewWidget={() => {
                  pulsoidClient.reportRecommendedWidgetAdded(widget.id);
                  window.open(
                    buildRoute({
                      path: DASHBOARD_ROUTES.CONFIGURATION_ADD_WIDGET,
                      params: {predefinedWidgetId: widget.id},
                    }),
                    '_blank'
                  );
                }}
                showHeader={false}
                addButtonText={'Add & configure'}
              />
            ))}
            {integration}
          </CardGroup>
        </Row>
      </>
    );
  } else {
    return '';
  }
};
